<template>
  <router-link :to="`/actualites/${pub.slug}`" class="pub-card" :class="{ compact }">
    <div class="pub-media">
      <img v-if="pub.image" :src="pub.image" :alt="pub.titre" loading="lazy" />
      <div v-else class="pub-placeholder">
        <i class="bi" :class="cat.icon"></i>
      </div>
      <span v-if="pub.nbPhotos || pub.nbVideos" class="pub-medias">
        <span v-if="pub.nbVideos"><i class="bi bi-play-circle-fill"></i> {{ pub.nbVideos > 1 ? pub.nbVideos + " vidéos" : "Vidéo" }}</span>
        <span v-if="pub.nbPhotos"><i class="bi bi-images"></i> {{ pub.nbPhotos }}</span>
      </span>
      <span class="pub-tag" :style="{ '--tag': cat.color }">
        <i class="bi" :class="cat.icon"></i>
        {{ pub.categorieLabel || cat.label }}
      </span>
    </div>

    <div class="pub-body">
      <div class="pub-meta">
        <span><i class="bi bi-calendar3"></i> {{ formatDate(pub.datePublication) }}</span>
        <span v-if="pub.filiale" class="pub-filiale">
          <i class="bi bi-building"></i> {{ pub.filiale.nom }}
        </span>
      </div>
      <h3 class="pub-title">{{ pub.titre }}</h3>
      <p v-if="!compact && pub.extrait" class="pub-excerpt">{{ pub.extrait }}</p>
      <span class="pub-more">Lire la suite <i class="bi bi-arrow-right"></i></span>
    </div>
  </router-link>
</template>

<script setup>
import { computed } from "vue";
import { CATEGORIES, formatDate } from "@/composables/useSite";

const props = defineProps({
  pub: { type: Object, required: true },
  compact: { type: Boolean, default: false },
});

const cat = computed(() => CATEGORIES[props.pub.categorie] || CATEGORIES.actualite);
</script>

<style scoped>
.pub-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  color: inherit;
  text-decoration: none;
  box-shadow: 0 10px 30px rgba(15, 43, 69, 0.08);
  border: 1px solid rgba(15, 43, 69, 0.06);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  height: 100%;
}
.pub-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 22px 45px rgba(15, 43, 69, 0.16);
  color: inherit;
}

.pub-media {
  position: relative;
  aspect-ratio: 16 / 9;
  background: linear-gradient(135deg, #0f2b45, #163a57);
  overflow: hidden;
}
.pub-media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}
.pub-card:hover .pub-media img {
  transform: scale(1.06);
}
.pub-placeholder {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  font-size: 3rem;
  color: rgba(240, 201, 92, 0.75);
}
.pub-tag {
  position: absolute;
  top: 14px;
  left: 14px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #fff;
  color: var(--tag);
  font-size: 0.78rem;
  font-weight: 700;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.pub-medias {
  position: absolute;
  right: 12px;
  bottom: 12px;
  display: flex;
  gap: 6px;
}
.pub-medias span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  border-radius: 999px;
  background: rgba(15, 43, 69, 0.85);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  backdrop-filter: blur(4px);
}
.pub-medias i {
  color: #f0c95c;
}

.pub-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 22px 22px 24px;
  flex: 1;
}
.pub-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  font-size: 0.82rem;
  color: #6b7280;
}
.pub-meta i {
  color: #c9a227;
  margin-right: 3px;
}
.pub-title {
  font-size: 1.15rem;
  line-height: 1.4;
  margin: 0;
  color: #0f2b45;
  font-weight: 800;
}
.pub-excerpt {
  margin: 0;
  color: #4b5563;
  line-height: 1.7;
  font-size: 0.95rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.pub-more {
  margin-top: auto;
  padding-top: 6px;
  font-weight: 700;
  color: #0f2b45;
  font-size: 0.92rem;
}
.pub-more i {
  transition: transform 0.2s ease;
  display: inline-block;
}
.pub-card:hover .pub-more i {
  transform: translateX(4px);
}

.compact .pub-body {
  padding: 18px;
}
.compact .pub-title {
  font-size: 1.02rem;
}
</style>
